import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Card from '../Card';

export default () => (
  <>
    <Heading level={1}>Default Card</Heading>
    <Spacer size={16} />
    <Text>
      This is the <Code>{'Card'}</Code> component's default state. The default
      state is a plain card without a shadow.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center" expand={false}>
        <Card />
        <Spacer size={20} />
        <Code>{'shadow={false}'}</Code>
      </FlexView>
    </FlexView>
  </>
);
